import * as fromOrderEffect from './order.effect';
import * as fromBulkOrderEffect from './bulk-acceptance.effect';
import * as  fromCategoryEffcet from './all-categories.effect';

// includes all your effect classes in the Array
export const appBarrelEffect = [fromOrderEffect.OrderEffect, fromBulkOrderEffect.BulkAcceptanceEffect, fromCategoryEffcet.AllCategoriesEffect];